import { ArrowForward, LockOutlined } from '@mui/icons-material';
import { Box, Divider, Stack, styled, Typography } from '@mui/material';
import { useCandidateAuth } from 'features/auth';
import { memo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

interface ProcessedOfferFooterProps {
    onViewDetailsClick: () => void;
    jobDetailsPath: string;
}

function ProcessedOfferFooter({ onViewDetailsClick, jobDetailsPath }: ProcessedOfferFooterProps) {
    const { t } = useTranslation('candidateOffers');
    const { isAuthenticated, login } = useCandidateAuth();

    const handleClick = useCallback(() => {
        if (isAuthenticated) {
            onViewDetailsClick();
        } else {
            login(jobDetailsPath);
        }
    }, [ isAuthenticated, onViewDetailsClick, login, jobDetailsPath ]);

    return (
        <Root>
            <Divider />
            <LinkRow onClick={ handleClick }
                role="button"
            >
                { isAuthenticated ? (
                    <>
                        <Typography variant="body2">
                            { t('viewDetails') }
                        </Typography>
                        <ArrowForward fontSize="small" />
                    </>
                ) : (
                    <>
                        <LockOutlined fontSize="small" />
                        <Typography variant="body2">
                            { t('signInToViewDetails') }
                        </Typography>
                    </>
                ) }
            </LinkRow>
        </Root>
    );
}

const LinkRow = styled(Box)(({ theme }) => ({
    cursor: 'pointer',
    color: theme.palette.text.secondary,
    alignSelf: 'flex-end',
    columnGap: theme.spacing(0.5),
    '&:hover': {
        color: theme.palette.text.primary
    },
    display: 'flex',
    alignItems: 'center'
}));

const Root = styled(Stack)(({ theme }) => ({
    paddingTop: theme.spacing(4),
    rowGap: theme.spacing(3)
}));

export default memo(ProcessedOfferFooter);
